import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const a1 = Math.floor(Math.random() * 10) - 5;  // pierwszy wyraz
  let r;
  do {
    r = Math.floor(Math.random() * 10) - 5;      // różnica ≠ 0
  } while (r === 0);

  const n = Math.floor(Math.random() * 10) + 2;   // n ≥ 2
  const x = a1 + (n - 1) * r;                     // x należy do ciągu

  return {
    type: "FindTermIndexTask",
    data: { a1, r, n, x }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { a1, r, x } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny, w którym{" "}
        <InlineMath math={`a_1 = ${a1}`} /> i{" "}
        <InlineMath math={`r = ${r}`} />.
      </p>
      <p>
        Wiadomo, że jednym z jego wyrazów jest liczba{" "}
        <InlineMath math={`${x}`} />.
      </p>
      <p>
        Podaj numer wyrazu <InlineMath math="n" />, dla którego{" "}
        <InlineMath math={`a_n = ${x}`} />.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseInt(userAnswer.raw);
  if (isNaN(given)) return false;

  return given === data.n;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath math={`n = ${data.n}`} />
  );
}

export function renderExplanation({ data }) {
  const { a1, r, n, x } = data;

  const numerator = x - a1;
  const denominator = r;
  const computedN = (numerator / denominator) + 1;

  const formattedNumeratorFirst =
    numerator < 0 ? `(${numerator})` : `${numerator}`;
    const formatForExpression = (val, operator = '') => {
  if (val < 0 && operator) {
    return `(${val})`;
  }
  return `${val}`;
};

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Ogólny wzór ciągu arytmetycznego i przekształcenie do <InlineMath math={`n`} />:
      </p>
      <BlockMath math={`a_n = a_1 + (n-1) \\cdot r`} />
      <BlockMath math={`n = \\frac{a_n - a_1}{r} + 1`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy i obliczamy:
      </p>
      <BlockMath math={`n = \\frac{${x} - (${a1})}{${r}} + 1`} />
      <BlockMath math={`n = \\frac{${formattedNumeratorFirst}}{${denominator}} + 1`} />
      <BlockMath math={`n = ${computedN}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return (
    <InlineMath math={`n = ${userAnswer.raw}`} />
  );
}
